module.exports = __webpack_public_path__ + "static/media/student-summary-mission01.fc75c7e5.png";